import {connect} from 'react-redux';
import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import ImportMutation from '../graphql/ImportMutation.graphql';
import {actions as system} from '../reducers/system';
import Message from '../enums/Message';
import $ from 'jquery';
import * as api from '../services/api';

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
			isLoading: state.system.isLoading
		}
	},
	dispatch => {
		return {
			addMessage: (message) => dispatch(system.addMessage(message)),
			startLoading: () => dispatch(system.startLoading()),
			endLoading: () => dispatch(system.endLoading())
		}
	}
)
@graphql(
	ImportMutation, {
		name: 'import'
	}
)
export default class ImportProject extends Component {

	constructor(prop) {
		super(prop);

		this.state = {
			file: null,
			checkVariables: true
		};

		this.fileInput = React.createRef();
	}

	import = () => {
		this.props.startLoading();

		api.uploadTranslationFile(this.state.file)
			.then(
				result => {
					this.props.import({
						variables: {
							project: this.props.selectedProject.name,
							file: result.data,
							checkPlaceholders: this.state.checkVariables
						}
					})
						.then(
							requestResult => {
								const importResult = requestResult.data.importProjectTranslations;

								if(importResult.hasValidationExceptions) {
									importResult.validationExceptions.forEach(exception => {
										this.props.addMessage(new Message(
											Message.TYPE_VALIDATION,
											400,
											exception.message
										));
									})
								} else {
									this.setState({
										import: importResult
									}, () => $('#import-modal-project').modal({backdrop: 'static', keyboard: false}))
								}
							},
							error => {
								this.props.addMessage(new Message(
									Message.TYPE_ERROR,
									500,
									'Could not import Translations: ' + error.message
								));
							}
						)
						.finally(this.props.endLoading);
				},
				error => {
					this.props.addMessage(new Message(
						Message.TYPE_ERROR,
						500,
						'Failed to upload file: ' + error.message
					));
				}
			);
	};

	componentDidMount() {
		$(this.fileInput.current).on('change.bs.fileinput', event => {
			this.setState({file: event.currentTarget.files[0]});
		});

		$(this.fileInput.current).on('clear.bs.fileinput', () => {
			this.setState({file: null});
		});
	}

	render() {
		return (
			<div className="card">
				<div id="import-modal-project" className="modal">
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<div className="modal-header">
								<h1>XLSX wurde importiert</h1>
							</div>
							<div className="modal-body">
								<h5>Updated Translations: {this.state.import? this.state.import.labelTranslationsUpdated: null}</h5>
								<h5>Affected Labels: {this.state.import? this.state.import.labelsAffectedCount: null}</h5>
								<h5>Updated LabelCollectionLanguages: {this.state.import? this.state.import.labelCollectionLanguagesUpdatedCount: null}</h5>
								<button className="btn btn-primary" onClick={() => {$('#import-modal-project').modal('hide'); this.props.history.push('/show/' + encodeURIComponent(this.props.selectedProject.name))}}>okay</button>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body">
					<div className="form-group has-label">
						<div className="fileinput fileinput-new text-center" data-provides="fileinput">
							<div className="form-control" data-trigger="fileinput">
								<span className="fileinput-filename"/>
							</div>
							<span>
								<span className="btn btn-danger btn-round input-group-text fileinput-exists"
									  data-dismiss="fileinput">
								  Remove
								</span>

								<span className="input-group-text btn btn-raised btn-round btn-default btn-file">
						  			<span className="fileinput-new">Select file</span>
						  			<span className="fileinput-exists">Change</span>
						  			<input type="file" name="file" ref={this.fileInput}/>
								</span>
							</span>
						</div>

						<div className="form-check xpull-left" >
							<label className="form-check-label">
								<input
									type="checkbox"
									className="form-check-input"
									checked={this.state.checkVariables}
									onChange={() => this.setState({checkVariables: !this.state.checkVariables})}
									name="checkPlaceholders"
								/>
								<span className="form-check-sign"/>
								Check variables in the texts. This option checks whether the necessary variables (values ​​in curly brackets) are contained in all texts. Only deactivate this check if you have checked the messages in the event of an unsuccessful import and the texts with missing variables are desired.
							</label>
						</div>

						<div>All collections contained in the import file must be locked by your user (happens automatically when exporting). These are released again when importing.</div>

						<button onClick={this.import} className="btn btn-primary" disabled={!this.state.file}>Import</button>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/screens/ImportProject.js